export const loadJS = (url, id) => {
  const existingJS = document.getElementById("id");
  if (existingJS) {
    console.log(`Skip loading ${id}. Already loaded`);
    return;
  }

  const js = document.createElement("script");
  js.src = url;
  js.id = id;
  js.async = false;
  document.getElementsByTagName("head")[0].appendChild(js);
  console.log(`Loading ${id}`, url);
};

export const loaded = callback => {
  if (document.readyState !== "loading") callback();
  // the following is not working for the salesforce chat
  // else document.addEventListener("DOMContentLoaded", callback);
  else window.addEventListener("load", callback);
};
